import { useMediaQuery } from '@material-ui/core';
import { Theme } from '../theme';

export function useShouldModalBeFullscreen() {
  return useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
}
